import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCurrencyDollar = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47716 6.47716 2 12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12ZM13 7.09236V7H11V7.09199C10.3784 7.20872 9.80346 7.43407 9.32396 7.75374C8.60228 8.23486 8 9.00935 8 10C8 10.9907 8.60227 11.7651 9.32396 12.2463C9.80346 12.5659 10.3784 12.7913 11 12.908V14.8492C10.609 14.7223 10.3192 14.5319 10.1567 14.3446L8.64607 15.6554C9.20855 16.3036 10.0596 16.7308 11 16.9076V17H13V16.908C13.6216 16.7913 14.1965 16.5659 14.676 16.2463C15.3977 15.7651 16 14.9907 16 14C16 13.0093 15.3977 12.2349 14.676 11.7537C14.1965 11.4341 13.6216 11.2087 13 11.092V9.15076C13.391 9.27772 13.6809 9.46811 13.8435 9.65544L15.3539 8.34456C14.7914 7.69637 13.9404 7.26916 13 7.09236ZM11 9.151C10.7794 9.22239 10.5882 9.31464 10.4334 9.41783C10.0693 9.66057 10 9.88609 10 10C10 10.1139 10.0693 10.3395 10.4334 10.5822C10.5882 10.6854 10.7794 10.7776 11 10.849V9.151ZM13 13.151V14.849C13.2206 14.7776 13.4118 14.6854 13.5666 14.5822C13.9307 14.3395 14 14.1139 14 14C14 13.8861 13.9307 13.6605 13.5666 13.4178C13.4118 13.3146 13.2206 13.2224 13 13.151Z"
        />
      </svg>
    );
  }
);
